import PropTypes from 'prop-types';
import r from 'render-dom';
import styled from 'styled-components';

const propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
};

const CardSection = styled.div`
    padding: ${({ hasTitle }) => hasTitle ? '10px 0' : 0};
`;

const Title = styled.span`
    color: #999;
    display: block;
    font-size: 12px;
    font-weight: 500;
    padding-bottom: 5px;
    text-transform: uppercase;
`;

export default function Section({ children, className = '', style = {}, title }) {
    const hasTitle = title && title.length > 0;

    return (
        r(CardSection, { className, style }, [
            r(Title, { hasTitle, isRendered: hasTitle }, [title]),
            children,
        ])
    );
}

Section.propTypes = propTypes;
